import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const points = [['😰', 'Llegás a clase sin saber exactamente qué actividad dar'], ['⏱️', 'Tardás horas planificando lo que podrías resolver en minutos'], ['🤷', 'No sabés cómo conectar la historia del arte sin sonar aburrido/a'], ['💸', 'No tenés evaluaciones claras ni rúbricas coherentes con el programa'], ['😓', 'Tus alumnos siempre hacen lo mismo y las clases no crecen'], ['😩', 'El domingo a la noche seguís sin tener el lunes preparado']];
export function PainPointsSection() {
  return <section className="bg-brand-alt px-4 py-20 sm:py-24" data-id="element-113" data-mp="3fg2b8d33qg6u">
      <Reveal className="mx-auto max-w-5xl" data-id="element-114" data-mp="3fhlwki3m7hfh">
        <SectionHeading title={<>
              <span aria-hidden="true" data-id="element-116" data-mp="3aishil8ojid7">👉</span> ¿Te reconocés en estas
              situaciones?
            </>} subtitle="Si respondés sí a alguna — este pack es para vos" data-id="element-115" data-mp="3ag68sia1ywte" />
        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-117" data-mp="surn6f1ynfvk">
          {points.map(([emoji, text]) => <article key={text} className="flex h-full items-start gap-4 rounded-2xl border border-brand-line bg-brand-cream p-6 text-left" data-id="element-118" data-mp="wvtor2jco40p">
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-119" data-mp="16uja55agg6lp">
                {emoji}
              </span>
              <p className="text-sm font-medium leading-snug text-brand-text sm:text-[15px]" data-id="element-120" data-mp="1bu5lf96q3crv">
                {text}
              </p>
            </article>)}
        </div>
        <p className="mt-12 text-center font-display text-lg italic text-brand-terra sm:text-xl" data-id="element-121" data-mp="1klxqt5gw3vpl">
          Y vos merecés mucho más que eso →
        </p>
      </Reveal>
    </section>;
}